module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"listeningMsg":"I am listening...","actionMsg":"Tap the microphone button, to ask me a question."},"es":{"listeningMsg":"Estoy escuchando...","actionMsg":"Toca el botón del micrófono, para preguntarme algo."}}')
  delete Component.options._Ctor
}
